<style>
    footer {
        @apply flex justify-center;
    }
    a {
        @apply font-bold text-black hover:underline;
    }
</style>

<footer>
    <span>
        © {new Date().getFullYear()}, Built by
        <a
          href="https://www.ryounus.dev"
        >
          RYounus
        </a>
        ✨
      </span>
</footer>